import React from "react";
import { PropertyButtonsMain } from "./PropertyButtonsMain";
import { PropertyButtonsSecondary } from "./PropertyButtonsSecondary";
import { IPropertyResult } from "@/interfaces/property";

export const PropertyButtons: React.FC<{property: IPropertyResult}> = ({property}) => {
  return (
    <section id="PropertyButtons" className="flex flex-col items-center w-full gap-[12px]">
      <PropertyButtonsMain property={property} />
      <PropertyButtonsSecondary property={property}  />
    </section>
  );
};

